// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"d3aa2f76","804":"7dc65891","818":"3d876863","922":"3415044c"}[chunkId] + ".chunk.js";
};